import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

/**
 * Marche a suivre pour installer l'application sur iPad (et iPhone).
 *
 * Safari ne donne aucune invite d'installation : la personne passe par « Partager » puis « Sur l'ecran
 * d'accueil ». Cette boite remplace l'invite. Maquette « Installer l'application admin », ecran 3.
 *
 * Les etapes portent un `<strong>` : leurs textes viennent des fichiers de traduction du depot (jamais d'une
 * saisie), et Angular assainit de toute facon `[innerHTML]`.
 */
@Component({
  selector: 'app-dialogue-installation-ios',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, DialogModule, ButtonModule],
  template: `
    <p-dialog
      [visible]="visible()"
      (visibleChange)="visible.set($event)"
      [modal]="true"
      [draggable]="false"
      [dismissableMask]="true"
      [closable]="true"
      [style]="{ width: '480px', maxWidth: '94vw' }"
    >
      <ng-template #header>
        <div class="ios-entete">
          <div class="ios-icone" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18M7 16l4-8 4 4 4-6"/></svg>
          </div>
          <div>
            <h2 class="ios-titre">{{ 'PWA.IOS_TITLE' | translate }}</h2>
            <p class="ios-sous-titre">{{ 'PWA.IOS_SUBTITLE' | translate }}</p>
          </div>
        </div>
      </ng-template>

      <ol class="ios-etapes">
        <li>
          <span class="ios-numero" aria-hidden="true">1</span>
          <span class="ios-texte" [innerHTML]="'PWA.IOS_STEP1' | translate"></span>
          <span class="ios-pictogramme" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="m8 7 4-4 4 4"/><path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8"/></svg>
          </span>
        </li>
        <li>
          <span class="ios-numero" aria-hidden="true">2</span>
          <span class="ios-texte" [innerHTML]="'PWA.IOS_STEP2' | translate"></span>
          <span class="ios-pictogramme" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>
          </span>
        </li>
        <li>
          <span class="ios-numero" aria-hidden="true">3</span>
          <span class="ios-texte" [innerHTML]="'PWA.IOS_STEP3' | translate"></span>
        </li>
      </ol>

      <p class="ios-pied">{{ 'PWA.IOS_FOOTER' | translate }}</p>

      <ng-template #footer>
        <p-button [label]="'PWA.IOS_CLOSE' | translate" (onClick)="visible.set(false)" />
      </ng-template>
    </p-dialog>
  `,
  styles: [`
    .ios-entete { display: flex; align-items: center; gap: 14px; }
    .ios-icone { flex: none; width: 56px; height: 56px; border-radius: 14px; background: linear-gradient(135deg, #7f77dd, #9b6bc4); display: flex; align-items: center; justify-content: center; }
    .ios-titre { margin: 0; font-size: 1.25rem; font-weight: 800; }
    .ios-sous-titre { margin: 3px 0 0; font-size: 0.8125rem; color: #6b7280; font-weight: 400; }
    .ios-etapes { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 16px; }
    .ios-etapes li { display: flex; align-items: center; gap: 14px; }
    .ios-numero { flex: none; width: 28px; height: 28px; border-radius: 50%; background: #ece9fb; color: #5b52c4; font-size: 0.8125rem; font-weight: 700; display: flex; align-items: center; justify-content: center; }
    .ios-texte { flex: 1; font-size: 0.9375rem; line-height: 1.4; }
    .ios-pictogramme { flex: none; width: 44px; height: 44px; border-radius: 12px; background: #f3f4f6; color: #111827; display: flex; align-items: center; justify-content: center; }
    .ios-pied { margin: 22px 0 0; padding: 12px 14px; border-radius: 10px; background: #f8f7fc; border: 1px solid #e9e7f5; font-size: 0.8125rem; line-height: 1.5; color: #4b5563; }
  `],
})
export class DialogueInstallationIosComponent {
  readonly visible = model(false);
}
